export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '80b9d564-0781-433e-b23d-77c86e3c49ec';
export const MODAL_CLOSE_SEC = 2.5;
